module.exports = __webpack_public_path__ + "media/images/case-pic2-8a7dd7c4.png";